var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26885 0C8.08995 0 10.3878 2.29787 10.3878 5.11898C10.3878 6.26648 9.7326 7.63681 9.30544 8.43046L5.72215 15.0851C5.66395 15.1959 5.5673 15.2815 5.45042 15.3258C5.33342 15.3702 5.2044 15.3702 5.0874 15.3258C4.97052 15.2815 4.87387 15.1959 4.81567 15.0851L1.23238 8.43046C0.805193 7.63693 0.149995 6.2666 0.149995 5.11898C0.149995 2.29787 2.44787 0 5.26897 0H5.26885ZM5.26885 1.02386C3.00108 1.02386 1.17367 2.85124 1.17367 5.11904C1.17367 5.80556 1.75702 7.23622 2.13884 7.94514L5.26873 13.7573L8.39892 7.94514C8.78062 7.2361 9.36397 5.80556 9.36397 5.11904C9.36397 2.85127 7.53659 1.02386 5.26879 1.02386H5.26885ZM5.26885 2.38895C6.77057 2.38895 7.99903 3.61738 7.99903 5.11913C7.99903 6.62088 6.77072 7.84931 5.26885 7.84931C3.76713 7.84931 2.53867 6.62088 2.53867 5.11913C2.53867 3.61738 3.76698 2.38895 5.26885 2.38895ZM5.26885 3.4128C4.32047 3.4128 3.56252 4.17075 3.56252 5.11913C3.56252 6.06751 4.32034 6.82545 5.26885 6.82545C6.21723 6.82545 6.97517 6.06751 6.97517 5.11913C6.97517 4.17075 6.21723 3.4128 5.26885 3.4128Z",
    fill: "#81AAB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIconBlue);
export default __webpack_public_path__ + "static/media/location-pin-icon-blue.7fe6192240cd5b513109cf16679fc1fa.svg";
export { ForwardRef as ReactComponent };